const PHOTOS_PATH = `${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/about-us/leadership`

/** Medida dos arquivos no S3: todas as fotos têm 656 x 700. */
export const PHOTO_WIDTH = 656
export const PHOTO_HEIGHT = 700

export type Leader = {
  id: string
  name: string
  role: string
  photo: string
}

export const leaders: Leader[] = [
  { id: 'juliano-belo', name: 'Juliano Bello', role: 'CEO', photo: `${PHOTOS_PATH}/juliano-belo.webp` },
  {
    id: 'camila-risden',
    name: 'Camila Risden',
    role: 'Marketing e CX',
    photo: `${PHOTOS_PATH}/camila-risden.webp`
  },
  { id: 'claudia-santoro', name: 'Claudia Santoro', role: 'P&P e GRC', photo: `${PHOTOS_PATH}/claudia-santoro.webp` },
  { id: 'felipe-molina', name: 'Felipe Molina', role: 'Tecnologia', photo: `${PHOTOS_PATH}/felipe-molina.webp` },
  { id: 'jonathan-hron', name: 'Jonathan Aryeh Hron', role: 'Financeiro', photo: `${PHOTOS_PATH}/jonathan-hron.webp` },
  { id: 'magally-aleixo', name: 'Magally Aleixo', role: 'Comercial', photo: `${PHOTOS_PATH}/magally-aleixo.webp` },
  { id: 'mariana-alves', name: 'Marina Alves', role: 'Produtos e Operações', photo: `${PHOTOS_PATH}/mariana-alves.webp` },
  {
    id: 'leandro-mello',
    name: 'Leandro Mello',
    role: 'Jurídico e Recup. de Crédito',
    photo: `${PHOTOS_PATH}/leandro-mello.webp`
  }
]
